<div class="mt-4">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary card-header-icon">
            <div class="card-icon">
              <i class="material-icons">chrome_reader_mode</i>
            </div>
            <h4 class="card-title">Container Type</h4>
          </div>
          <div class="card-body">
            <loading *ngIf="loading"></loading>

            <dinamic-table
              *ngIf="!loading"
              [id]="'containertypeTable'"
              [data]="data"
              [frontpaginate]="true"
              [newbutton]="true"
              (action_button)="action($event)"
            ></dinamic-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div>
  <div id="modalmethod" class="modal" tabindex="-1" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Container Type</h5>
          <button
            type="button"
            class="close"
            (click)="closeModal()"
            aria-label="Close"
            data-dismiss="modal"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <div class="modal-body">
          <form #f="ngForm">
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="nombre" class="form-label">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="nombre"
                    name="nombre"
                    placeholder="Container Type Name"
                    [(ngModel)]="method.name"
                    required
                  />
                </div>
                <div class="mb-3">
                  <label for="nombre" class="form-label">Points</label>
                  <input
                    type="number"
                    class="form-control"
                    id="point"
                    name="point"
                    placeholder="Points"
                    [(ngModel)]="method.points"
                    required
                  />
                </div>
                <div class="mb-3">
                  <label for="nombre" class="form-label">Tare</label>
                  <input
                    type="text"
                    class="form-control"
                    id="tare"
                    name="tare"
                    placeholder="Tare"
                    [(ngModel)]="method.tare"
                    required
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="closeModal()"
          >
            Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="save()"
            [disabled]="!f.valid || saving"
          >
            <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            Save changes
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
